/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */

import React from 'react';

// Use relative imports to avoid build tools trying to resolve bare module specifiers
// (some bundlers/environments can't resolve 'parts/Header' -> this fixes that)
import Discuss from 'parts/Discuss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { Fade } from "react-awesome-reveal";
import Button from 'elements/Button';

// Some CI/build environments fail when importing image assets via unresolved paths.
// To avoid build errors in minimal/test environments, use a safe fallback image URL.
// If you have the actual image available at '../../assets/images/Industries/Financial_Services_and_Accounting_Firms.png'
// you can uncomment the import below and remove the fallback constant.
// import FinancialImage from '../../assets/images/Industries/Financial_Services_and_Accounting_Firms.png';

export default function FinancialServicesAndAccountingFirms() {
  return (
    <>
      {/* CHALLENGES SECTION */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl lg:text-4xl text-theme-blue font-extrabold text-center mb-6">Challenges in Financial Technology</h2>
          <p className="text-center text-gray-600 mb-10">Security, compliance, and efficiency are mission‑critical for financial organizations.</p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

            <div className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold text-theme-blue mb-2">Data Security & Encryption</h3>
              <p className="text-gray-600">Protect sensitive financial data with secure storage, encrypted communication, and breach prevention systems.</p>
            </div>

            <div className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold text-theme-blue mb-2">Regulatory Compliance</h3>
              <p className="text-gray-600">Solutions built to meet FINTRAC, PCI‑DSS, SOC2, and other financial compliance requirements.</p>
            </div>

            <div className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold text-theme-blue mb-2">Workflow Automation</h3>
              <p className="text-gray-600">Digitize manual processes such as bookkeeping, reporting, tax preparation, approvals, and document management.</p>
            </div>

          </div>
        </div>
      </section>

      {/* BENEFITS SECTION */}
      <section className="py-16">
        <div className="container mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

          <div>
            <h2 className="text-3xl lg:text-4xl text-theme-blue font-extrabold mb-4">How We Support Financial Organizations</h2>
            <ul className="space-y-6 text-gray-600">

              <li className="flex items-start gap-4">
<Fade triggerOnce delay={20}>
                  <span className="text-2xl leading-none"> <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#47d14a" }} /> </span></Fade>
                <div>
                  <p className="font-semibold">Stronger Cybersecurity</p>
                  <p className="text-sm">Zero‑trust networks, MFA, encrypted backups, and real‑time threat monitoring reduce every attack surface.</p>
                </div>
              </li>

              <li className="flex items-start gap-4">
<Fade triggerOnce delay={20}>
                  <span className="text-2xl leading-none"> <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#47d14a" }} /> </span></Fade>
                <div>
                  <p className="font-semibold">More Efficient Operations</p>
                  <p className="text-sm">Automated workflows, digital signatures, and integrated accounting systems improve daily productivity.</p>
                </div>
              </li>

              <li className="flex items-start gap-4">
<Fade triggerOnce delay={20}>
                  <span className="text-2xl leading-none"> <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#47d14a" }} /> </span></Fade>
                <div>
                  <p className="font-semibold">Improved Client Trust</p>
                  <p className="text-sm">Reliable systems, accurate reporting, and secured communication channels enhance your firm’s reputation.</p>
                </div>
              </li>

            </ul>

            <div className="mt-6">
              <Button href="/contact" type="link" className="px-6 py-3 bg-theme-purple text-white rounded-full hover:bg-dark-theme-purple transition duration-200">Request a Compliance Assessment</Button>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-md p-6">
            <h3 className="text-xl font-semibold text-theme-blue mb-4">Typical Outcomes</h3>
            <div className="space-y-4 text-gray-600">
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Reduced compliance risk</strong></p>
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Higher data protection levels</strong></p>
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>More accurate reporting</strong></p>
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Faster, more organized operations</strong></p>
            </div>
          </div>

        </div>
      </section>

      {/* CTA SECTION */}
      <section className="py-16 bg-gradient-to-r from-light-theme-purple to-white">
        <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl lg:text-3xl text-theme-blue font-bold">Ready to secure and modernize your financial operations?</h2>
            <p className="text-gray-600 mt-2">We’ll help you stay compliant, secure, and efficient.</p>
          </div>

          <div>
            <Button href="/contact" type="link" className="px-6 py-3 bg-theme-purple text-white rounded-full hover:bg-dark-theme-purple transition duration-200">Get Started</Button>
          </div>
        </div>
      </section>

      <Discuss />
    </>
  );
}
